import { render, staticRenderFns } from "./singleVideo.vue?vue&type=template&id=e92a5b42&scoped=true&"
import script from "./singleVideo.vue?vue&type=script&lang=js&"
export * from "./singleVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92a5b42",
  null
  
)

export default component.exports